<i
  class="ri-edit-2-fill cursor-pointer"
  type="button"
  (click)="openModal()"
  data-testid="room-edit"
  i18n-tooltip="@@customize"
  tooltip="Anpassen"
  placement="top"
  container="body"
></i>